

export const STATE_SAVED = 1;
export const STATE_ANALYSE = 2;
export const STATE_PRISE_EN_COMPTE = 3;
export const STATE_TERMINER = 4;
export const STATE_ANNULER = -1;


export const societes = {
    1:'CIE',
    2:'SODECI',
    3:'CIE & SODECI'
}


export const FICHE_STATES = [
    {
        state: 'App\\Models\\Fiches\\States\\WaitingUserConfirmationStep',
        label: 'En attente de confirmation',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\FicheTransmittedStep',
                default: true
            }
        ],
        classes: 'label-dark',
    },
    {
        state: 'App\\Models\\Fiches\\States\\FicheTransmittedStep',
        label: 'Demande transmise',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\AnalyseStep',
                default: true
            }
        ],
        styles: {
            background: '#fce738',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\AnalyseStep',
        label: 'Demande Analysée',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\VisitPlanifiedStep',
                default: true
            }
        ],
        classes: 'label ',
        styles: {
            background: '#fa853c',
            color: '#ff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\VisitPlanifiedStep',
        label: 'Visite planifiée',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\VisitDoneStep',
                default: true
            }
        ],
        classes: 'label',
        styles: {
            background: '#F64E60',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\VisitDoneStep',
        label: 'Visite réalisée',
        nextStepsCIE: [
            {
                state: 'App\\Models\\Fiches\\States\\WorkToDoObservedStep',
                default: true
            },
            {
                state: 'App\\Models\\Fiches\\States\\NoWorkToDoStep',
            }
        ],
        nextStepsSODECI: [
            {
                state: 'App\\Models\\Fiches\\States\\DevisSendedStep',
                default: true
            },
        ],
        classes: 'label-dark',
        styles: {
            background: '#d626e6',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\WorkToDoObservedStep',
        label: 'Travaux à effectuer observés',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\DevisSendedStep',
                default: true
            }
        ],
        styles: {
            backgroundColor: '#1ea759',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\NoWorkToDoStep',
        label: 'Pas de travaux observé',
        nextStepsCIE: [
            {
                state: 'App\\Models\\Fiches\\States\\CloturedByNoWorkToDoStep',
                default: true
            }
        ],
        styles: {
            backgroundColor: '#1ea759',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\DevisSendedStep',
        label: 'Devis transmis',
        nextStepsSODECI: [
            {
                state: 'App\\Models\\Fiches\\States\\CommandSendedStep',
                default: true
            }
        ],
        nextStepsCIE: [
            {
                state: 'App\\Models\\Fiches\\States\\DevisAcceptedStep',
                default: true
            },
            {
                state: 'App\\Models\\Fiches\\States\\DevisDeniedStep',
            }
        ],
        styles: {
            background: '#8950FC',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\StudyFinishedStep',
        label: 'Etude finalisée',
        styles: {
            background: '#4a33d5',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\CommandSendedStep',
        label: 'Commande transmise',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\WorkInProgressStep',
                default: true
            }
        ],
        styles: {
            background: '#3699FF',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\WorkInProgressStep',
        label: 'Travaux en cours',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\WorkFinishedStep',
                default: true
            }
        ],
        styles: {
            backgroundColor: '#1bc5bd',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\DevisAcceptedStep',
        label: 'Devis accepté',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\CommandSendedStep',
                default: true
            }
        ],
        styles: {
            background: '#8950FC',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\DevisDeniedStep',
        label: 'Devis refusé',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\DevisMOSendedStep',
                default: true
            }
        ],
        styles: {
            background: '#8950FC',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\WorkFinishedStep',
        label: 'Travaux terminés',
        nextStepsCIE: [
            {
                state: 'App\\Models\\Fiches\\States\\WorkFinishedConfirmedByClient',
                default: true
            },
            {
                state: 'App\\Models\\Fiches\\States\\WorkFinishedDeniedByClient',
            },
        ],
        styles: {
            backgroundColor: '#1ea759',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\WorkFinishedConfirmedByClient',
        label: 'Travaux terminés confirmés par le client',
        styles: {
            backgroundColor: '#1ea759',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\CloturedStep',
        label: 'Demande clôturée',
        styles: {
            backgroundColor: '#1ea759',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\CloturedByNoWorkToDoStep',
        label: 'Demande clôturée (Pas de travaux)',
        styles: {
            backgroundColor: '#1ea759',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\DevisMOSendedStep',
        label: 'Devis MO Envoyé',
        nextSteps: [
            {
                state: 'App\\Models\\Fiches\\States\\CloturedStep',
                default: true
            }
        ],
        styles: {
            backgroundColor: '#1ea759',
            color: '#fff'
        }
    },
    {
        state: 'App\\Models\\Fiches\\States\\WorkFinishedDeniedByClient',
        label: 'Travaux terminés infirmés par le client',
        styles: {
            backgroundColor: '#a71e49',
            color: '#fff'
        }
    },
];


